import { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import classes from "./BenchMarkResults.module.css";
import { Column, TwoColumnLayout } from "../../../Shared/FlexDiv/FlexDiv";
import axios from "../../../../Axios";
import { Urls } from "../../../../Urls";
import {
  Activity,
  currentRequestTimeStamp,
  isMobile,
} from "../../../../Constants";
import Rating from "react-rating";
import "./styles.css";
import NewEnquiry from "../../../TrucksAvailable/NewEnquiry/NewEnquiry";
import RatesModal from "../../../Shared/PopupModal/PopupModal";
import ReactTooltip from "react-tooltip";
import UpgradeModal from "../../../UpgradeModal/UpgradeModal";
import mixpanel from "mixpanel-browser";
import ProfileModal from "../../../TransporterClientScreen/ProfileModal/ProfileModal";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";
import CalendlyPopupButton from "../../../Shared/CalendlyPopupButton/CalendlyPopupButton";
import { CALENDLY_URL } from "../../../../config/calendly";
import { useExpressInterest } from "../../../../hooks/useExpressInterest";

// exported to use in showUploadedLanes component
export const ViewLSP = ({ item }) => {
  const transporterList = item?.transporter_list || [];
  const totalTransporters = item?.dashboard?.[3]?.value || 0;

  return (
    <div style={{ width: "100%", maxHeight: "40vh", overflowY: "auto" }}>
      <p style={{ lineHeight: "1.2", fontSize: "12px" }} className="m-0">
        Showing{" "}
        <b>
          {transporterList.length} of {totalTransporters}
        </b>{" "}
        Transporters
      </p>
      {transporterList.length > 0 ? (
        transporterList.map((tname, index) => (
          <div key={index} className="row border-bottom py-1">
            <div className="col-md-8">
              <ProfileModal
                transporter_list={transporterList}
                transporter_id={tname.transporter_id}
                transporter_name={tname.transporter_name}
                screenName="My Freight Benchmark"
                moduleName="Benchmark Results"
                style={{ fontSize: "12px" }}
                buttonClass={`${classes["own-modal-style"]} btn-link`}
                styleforModal={{ paddingRight: "1%" }}
              />
            </div>
            <div className=" text-end">
              <Rating
                initialRating={tname.overall_rating}
                readonly
                emptySymbol={`fa fa-star ${classes["star-1"]}`}
                fullSymbol={`fa fa-star ${classes["star-1-selected"]}`}
              />
            </div>
          </div>
        ))
      ) : (
        <div className="text-muted">No Transporter Found For This Lane</div>
      )}
    </div>
  );
};

const BenchMarkResults = ({
  sessionid = "",
  allowedrate = "no",
  currentLaneList,
  updateCurrentLaneList,
  lspLanes,
  setLspLanes,
  qualitativeInputs,
  resetData,
  toggleNav,
  allowedtransporter,
  onCalendlyScheduled
}) => {
  const history = useHistory();
  const [selectedlanesforrates, setselectedlanesforrates] = useState([]);
  const [updatetoggle, setupdatetoggle] = useState(true);
  const [wantsMegaRFQ, setWantsMegaRFQ] = useState(true);
  // const [buttondisable, setbuttondisable] = useState(false)
  const [lspload, setlspload] = useState(true);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { submitMegaRFQInterest } = useExpressInterest();

  const goToStart = () => {
    Activity([
      {
        screen: "My Freight Benchmark",
        module: "Exit button",
        user_activity: "User Clicked on Exit Button",
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    if (!isMobile()) toggleNav();
    window.location.reload();
  };

  useEffect(() => {
    if (sessionid) {
      getSessionDetails();
    }
    if (qualitativeInputs && qualitativeInputs.benchmark_unseen) {
      setupdatetoggle(qualitativeInputs.benchmark_unseen.value);
    }
  }, []);
  const getSessionDetails = () => {
    setlspload(true);
    axios
      .post(`${Urls.benchmarnow}?field=transporter_list`, {
        network: currentLaneList,
        session_created_on: new Date().toISOString(),
      })
      .then((res) => {
        updateCurrentLaneList([]);
        var lspl = lspLanes.slice();

        lspl.map((value, index) => {
          res.data.network.map((val) => {
            if (value.laneKey === val.laneKey) {
              if (
                val.transporter_dashboard &&
                val.transporter_dashboard.transporter_list
              ) {
                value.benchmarknow_analysis.transporter_list =
                  val.transporter_dashboard.transporter_list;
              }
              if (
                value.benchmarknow_analysis.dashboard &&
                val.transporter_dashboard &&
                val.transporter_dashboard.dashboard
              ) {
                value.benchmarknow_analysis.dashboard[2] =
                  val.transporter_dashboard.dashboard[0];
                value.benchmarknow_analysis.dashboard[3] =
                  val.transporter_dashboard.dashboard[1];
              }
            }
          });
        });

        setLspLanes(lspl);
        var rspl = [];
        // lspl.map(item => {
        //     if (item.origin_name && item.destination_name && item.truck_type) {
        //         rspl.push({ value: item, label: `${item.origin_name}- ${item.destination_name} (${item.truck_type}) ` })
        //         setselectedlanesforrates(rspl)
        //     }
        // })
        lspl.map((item) => {
          if (item.origin_name && item.destination_name && item.truck_type) {
            rspl.push({
              value: item,
              label: `${item.origin_name} - ${item.destination_name} (${item.truck_type})`,
            });
            setselectedlanesforrates(rspl);
          }
        });
        setlspload(false);
      })
      .catch((err) => {
        console.log(err);
        // setShow(false)
      });
  };

  const openUpdatePreference = () => {
    if (updatetoggle) {
      document.getElementById("tnc").click();
    }
  };

  // const oncloseHandler = () => {
  //     if(updatetoggle)  {
  //         document.getElementById("close_contactus").click()
  //         setupdatetoggle(false)
  //         document.getElementById('rates_modal').click()
  //     }
  // }
  const insertActivity = (e) => {
    Activity([
      {
        screen: "My Freight Benchmark",
        module: "Get Rates",
        user_activity:
          "Get Rates from Transporters Button Clicked in My Freight Benchmark",
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    mixpanel.track(`User has clicked get rates from transporters`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Benchmark",
      ModuleName: "landing_page",
      ActivityLog: "userClickedGetRatesFromTransporters",
      Data: `None`,
      Definition: `User has clicked get rates from transporters`,
      ActivityType: "event_view",
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`,
    });
  };

  const termsClick = () => {
    mixpanel.track(`User has clicked on terms of use and disclaimers`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Benchmark",
      ModuleName: "benchmark_page",
      ActivityLog: "userClickedTermsOfUseAndDisclaimers",
      Data: `None`,
      Definition: `User has clicked on terms of use and disclaimers`,
      ActivityType: "event_view",
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`,
    });
  };

  const expressInterestClick = () => {
    submitMegaRFQInterest({ moduleName: "benchmark results", wantsMegaRFQ });
  };

  const MobileBody = () => {
    return (
      <Column
        className={`${classes["fixed-flex-height"]}`}
        style={{ height: "auto" }}
      >
        {lspLanes && lspLanes.length > 0 ? (
          lspLanes.map((item, index) => {
            return (
              <Column
                key={index}
                className={classes["BenchMark-Table-Body-Row-Mobile"]}
              >
                <TwoColumnLayout
                  leftColumn={
                    <label className={classes["font-size-label"]}>Origin</label>
                  }
                  rightColumn={
                    // item.origin && item.origin.location_name ? item.origin.location_name : ''
                    item.origin_name ? item.origin_name : ""
                  }
                />
                <TwoColumnLayout
                  leftColumn={
                    <label className={classes["font-size-label"]}>
                      Destination
                    </label>
                  }
                  rightColumn={
                    item.destination_name ? item.destination_name : ""
                  }
                />
                <TwoColumnLayout
                  leftColumn={
                    <label className={classes["font-size-label"]}>
                      Truck Type
                    </label>
                  }
                  rightColumn={
                    item.truck_type ? <span>{item.truck_type}</span> : ""
                  }
                />
                <TwoColumnLayout
                  leftColumn={
                    <label className={classes["font-size-label"]}>
                      Median Rate (
                      {companySettingData?.default_currency?.default_currency
                        ?.cc ?? "INR"}
                      )
                    </label>
                  }
                  rightColumn={
                    item.benchmarknow_analysis &&
                      item.benchmarknow_analysis.dashboard ? (
                      <span style={{ fontSize: "16px", fontWeight: "bolder" }}>
                        &#8377;{" "}
                        {numberWithCommas(
                          item.benchmarknow_analysis.dashboard[0].value,
                        )}
                      </span>
                    ) : (
                      "-"
                    )
                  }
                />
                {/* <TwoColumnLayout
                  leftColumn={
                    <label className={classes["font-size-label"]}>
                      Maximum Rate (
                      {companySettingData?.default_currency?.default_currency
                        ?.cc ?? "INR"}
                      )
                    </label>
                  }
                  rightColumn={
                    item.benchmarknow_analysis &&
                      item.benchmarknow_analysis.dashboard ? (
                      <>
                        {" "}
                        {item.benchmarknow_analysis.dashboard[1].value &&
                          item.benchmarknow_analysis.dashboard[1].value !==
                          "-" ? (
                          // <span style={{fontSize: '16px', fontWeight: 'bolder'}}></span> :
                          <> </>
                        ) : null}
                        <span
                          style={{ fontSize: "16px", fontWeight: "bolder" }}
                        >
                          &#8377;{" "}
                          {numberWithCommas(
                            item.benchmarknow_analysis.dashboard[1].value,
                          )}
                        </span>
                      </>
                    ) : (
                      "-"
                    )
                  }
                /> */}
                <TwoColumnLayout
                  leftColumn={
                    <label className={classes["font-size-label"]}>
                      Actions
                    </label>
                  }
                  rightColumn={
                    lspload ? (
                      <div className={`${classes["my-row"]}`}>
                        <div className={`${classes["my-loader"]}`} />
                        <span
                          style={{
                            textAlign: "left",
                            marginLeft: "7%",
                            marginTop: "-3%",
                            fontSize: "12px"
                          }}
                        >
                          Fetching Transporters...
                        </span>
                      </div>
                    ) : (
                      (() => {
                        const transporterCount = item.benchmarknow_analysis &&
                          item.benchmarknow_analysis.dashboard &&
                          item.benchmarknow_analysis.dashboard[3]
                          ? parseInt(item.benchmarknow_analysis.dashboard[3].value, 10) || 0
                          : 0;
                        return (
                          <div style={{ display: "flex", gap: "8px" }}>
                            <RatesModal
                              buttonLabel={
                                <span>
                                  View Transporters ({transporterCount})
                                </span>
                              }
                              buttonClass={classes["btn-view-transporters"]}
                              content={<ViewLSP item={item.benchmarknow_analysis} />}
                              title={item.laneKey}
                              titleSize="sm"
                              id={`editenquiry_${index}`}
                              size="md"
                              screenName="My Freight Benchmark"
                              variant="popover"
                              moduleName="View LSP"
                              activityName="View LSP Button Clicked"
                            />
                          </div>
                        );
                      })()
                    )
                  }
                />
              </Column>
            );
          })
        ) : (
          <h3>{""}</h3>
        )}
      </Column>
    );
  };

  const numberWithCommas = (x) => {
    if (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  };

  const Table = () => {
    return (
      <div className={classes["t-container"]}>
        <table className={classes["table-s"]}>
          <thead style={{ textAlign: "center" }}>
            <tr>
              <th style={{ width: "8%", textAlign: "center" }}>Sr. No.</th>
              <th style={{ width: "20%", textAlign: "center" }}>Origin</th>
              <th style={{ width: "20%", textAlign: "center" }}>
                Destination
              </th>
              <th style={{ width: "20%", textAlign: "center" }}>
                Truck Type
              </th>
              <th style={{ width: "14%", textAlign: "center" }}>
                Median Rate
              </th>
              <th style={{ width: "18%", textAlign: "center" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {lspLanes && lspLanes.length > 0
              ? lspLanes.map((item, index) => {
                return (
                  <tr key={index}>
                    <td style={{ width: "8%", textAlign: "center" }}>
                      {index + 1}
                    </td>
                    <td style={{ width: "20%", textAlign: "center" }}>
                      {item.origin_name ? item.origin_name : ""}
                    </td>
                    <td style={{ width: "20%", textAlign: "center" }}>
                      {item.destination_name
                        ? item.destination_name
                        : ""}
                    </td>
                    <td style={{ width: "20%", textAlign: "center" }}>
                      {item.truck_type ? (
                        <span>{item.truck_type}</span>
                      ) : (
                        ""
                      )}
                    </td>
                    <td style={{ width: "14%", textAlign: "center" }}>
                      <div className={`${classes["medmaxdata"]}`}>
                        {item.benchmarknow_analysis &&
                          item.benchmarknow_analysis.dashboard ? (
                          <>
                            &#8377;{" "}
                            {numberWithCommas(
                              item.benchmarknow_analysis.dashboard[0]
                                .value,
                            )}
                          </>
                        ) : (
                          "-"
                        )}
                      </div>
                    </td>
                    <td style={{ width: "18%", textAlign: "center" }}>
                      <div data-tut="reactour__transporter-view" style={{ display: "flex", gap: "8px", justifyContent: "center", alignItems: "center" }}>
                        {lspload ? (
                          <div className={`${classes["my-row"]}`}>
                            <div className={`${classes["my-loader"]}`} />
                            <span
                              style={{
                                textAlign: "left",
                                marginLeft: "7%",
                                marginTop: "-3%",
                              }}
                            >
                              Fetching Transporters, Please Wait...
                            </span>
                          </div>
                        ) : (
                          (() => {
                            const transporterCount = item.benchmarknow_analysis &&
                              item.benchmarknow_analysis.dashboard &&
                              item.benchmarknow_analysis.dashboard[3]
                              ? parseInt(item.benchmarknow_analysis.dashboard[3].value, 10) || 0
                              : 0;
                            return allowedtransporter === 'yes' ? (
                              <RatesModal
                                buttonLabel={
                                  <span>
                                    View Transporters ({transporterCount})
                                  </span>
                                }
                                buttonClass={classes["btn-view-transporters"]}
                                content={
                                  <ViewLSP
                                    item={item.benchmarknow_analysis}
                                  />
                                }
                                size="sm"
                                title={item.laneKey}
                                titleSize="sm"
                                id={`editenquiry_${index}`}
                                variant="popover"
                                screenName="My Freight Benchmark"
                                moduleName="View LSP"
                                activityName="View LSP Button Clicked"
                              />
                            ) : (
                              <UpgradeModal
                                feature="View Transporter List"
                                screenName="My Freight Benchmark"
                                moduleName="Upgrade Popup"
                                activityName="View Transporters Button Clicked"
                                buttonClass={classes["btn-view-transporters"]}
                                buttonLabel={`View Transporters (${transporterCount})`}
                              />
                            );
                          })()
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })
              : null}
          </tbody>
        </table>
      </div>
    );
  };

  const Actions = () => {
    return (
      <div className="row" style={{ marginTop: "3%", display: "initial" }}>
        {!isMobile() ? (
          <div style={{ display: "flex", justifyContent: "center", width: "100%", margin: "24px 0" }}>
            <button
              className="btn"
              onClick={() => history.push("/lockinyoursavings")}
              style={{
                background: "#393185",
                border: "1px solid #393185",
                color: "white",
                fontSize: "15px",
                fontWeight: "600",
                padding: "10px 32px",
                borderRadius: "6px",
                cursor: "pointer",
                boxShadow: "0 4px 6px -1px rgba(57, 49, 133, 0.2), 0 2px 4px -1px rgba(57, 49, 133, 0.1)",
                transition: "all 0.2s ease"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = "#2e276b";
                e.currentTarget.style.transform = "translateY(-1px)";
                e.currentTarget.style.boxShadow = "0 6px 8px -1px rgba(57, 49, 133, 0.3), 0 3px 6px -1px rgba(57, 49, 133, 0.15)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = "#393185";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(57, 49, 133, 0.2), 0 2px 4px -1px rgba(57, 49, 133, 0.1)";
              }}
            >
              Lock in your Savings
            </button>
          </div>
        ) : (
            <div style={{ display: "flex", justifyContent: "center", width: "100%", margin: "16px 0" }}>
              <button
                className="btn"
                onClick={() => history.push("/lockinyoursavings")}
                style={{
                background: "#393185",
                border: "1px solid #393185",
                color: "white",
                fontSize: "15px",
                fontWeight: "600",
                padding: "10px 32px",
                borderRadius: "6px",
                cursor: "pointer",
                boxShadow: "0 4px 6px -1px rgba(57, 49, 133, 0.2), 0 2px 4px -1px rgba(57, 49, 133, 0.1)",
                transition: "all 0.2s ease"
              }}
                onMouseOver={(e) => { e.currentTarget.style.background = "#2e276b"; }}
                onMouseOut={(e) => { e.currentTarget.style.background = "#393185"; }}
              >
                Lock in your Savings
              </button>
            </div>
        )}
      </div>
    );
  };

  const allLanesForRates = lspLanes.map(item => ({
    value: item,
    label: `${item.origin_name} - ${item.destination_name} (${item.truck_type})`
  }));

  return (
    <>
      {!isMobile() ? (
        <>
          <div
            style={{ display: "flex", justifyContent: "flex-end", paddingRight: "5%", marginTop: "12px", marginBottom: "-12px" }}
            data-tut="reactour__transporter-tnc"
          >
            <span id="definition" data-tip data-for="definition" style={{ cursor: "pointer" }}>
              <i className="fa fa-info-circle" style={{ fontSize: "20px", color: "#393185" }}></i>
            </span>
            <ReactTooltip
              className={`${classes["tooltip"]}`}
              id="definition"
              place="bottom"
              effect="float"
              backgroundColor="#393185 !important"
            >
              <div>
                <b>Median:</b> <br />
                The central value of freight based on available freight rates
                <br />
                {/* <b>Max:</b> <br />
                The maximum value of freight based on available freight rates
                <br /> */}
                <b>Note:</b> <br />
                Freight rates in LoRRI Benchmark are based on industry standard
                terms and conditions and may vary based on your specific terms,
                conditions and volume requirements
              </div>
            </ReactTooltip>
          </div>
          <Table />

          {allowedrate === "yes" && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
                width: "92%",
                margin: "16px auto 0 auto",
              }}
            >
              <RatesModal
                screenName="My Freight Benchmark"
                moduleName="Get Rates"
                activityName={`Get Rates Button Clicked`}
                buttonLabel={"Get Spot Rates"}
                content={
                  <NewEnquiry
                    resetData={resetData}
                    backbutton={true}
                    newSpot={true}
                    rspl={allLanesForRates}
                  />
                }
                id={`rates_modal_all`}
                disabled={lspload}
                size="fullscreen"
                title="My Enquiries"
                buttonClass={classes["btn-get-spot-rates"]}
                overflowStyles={{
                  overflow: "hidden",
                  top: "9%",
                  zIndex: "999",
                }}
                closeButtonId={`close_contact_all`}
              />
            </div>
          )}

          <div className={classes["mbr-upsell-card-web"]} style={{ width: "50%", display: "flex", flexDirection: "column", gap: "24px", textAlign: "center", backgroundColor: "#f8fafc", alignItems: "center" }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "32px", alignItems: "center", width: "100%" }}>
               {/* Left Side */}
               <div style={{ display: "flex", flexDirection: "column", gap: "16px", alignItems: "center", textAlign: "center" }}>
                 <div className={classes["mbr-upsell-title-web"]} style={{ fontSize: "20px" }}>Want to benchmark more lanes?</div>
                 <div className={classes["mbr-upsell-text-web"]} style={{ fontSize: "14px", color: "#475569", maxWidth: "none" }}>
                   Unlock network-wide freight benchmarks and discover your full savings potential in a 20-minute demo.
                 </div>
               </div>
 
               {/* Right Side */}
               {/* <div style={{ display: "flex", flexDirection: "column", gap: "16px", borderLeft: "1px solid #e2e8f0", paddingLeft: "32px" }}>
                 <div className={classes["mbr-upsell-title-web"]} style={{ fontSize: "20px" }}>Join Mega RFQ</div>
                 <div className={classes["mbr-upsell-text-web"]} style={{ fontSize: "14px", color: "#475569", maxWidth: "none" }}>
                   Unlock Bigger Savings, Better Service and Greater Sustainability.
                 </div>
                 <label
                   style={{
                     display: "flex",
                     alignItems: "center",
                     gap: "10px",
                     cursor: "pointer",
                     userSelect: "none",
                     marginTop: "8px",
                     fontSize: "14px",
                     color: "#475569",
                   }}
                 >
                   <input
                     type="checkbox"
                     checked={wantsMegaRFQ}
                     onChange={(e) => setWantsMegaRFQ(e.target.checked)}
                     style={{ display: "none" }}
                   />
                   <div
                     style={{
                       width: "20px",
                       height: "20px",
                       borderRadius: "6px",
                       border: wantsMegaRFQ ? "none" : "2px solid #cbd5e1",
                       backgroundColor: wantsMegaRFQ ? "#16b364" : "transparent",
                       display: "flex",
                       alignItems: "center",
                       justifyContent: "center",
                       color: "#ffffff",
                       fontSize: "12px",
                       transition: "all 0.2s ease",
                     }}
                   >
                     {wantsMegaRFQ && <i className="fa fa-check" />}
                   </div>
                   <span>
                     I want to know more about <b>Mega RFQs</b>.
                   </span>
                 </label>
               </div> */}
            </div>

             {/* Centered Single Button for Both */}
             <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "16px", marginTop: "8px", width: "100%" }}>
               <button
                 className={classes["btn-exit-small"]}
                 onClick={goToStart}
                 style={{
                   height: "48px",
                   padding: "0 32px",
                   borderRadius: "10px",
                   fontSize: "15px",
                   fontWeight: "700",
                   border: "1.5px solid #cbd5e1",
                   backgroundColor: "#ffffff",
                   color: "#334155",
                   display: "inline-flex",
                   alignItems: "center",
                   justifyContent: "center",
                   cursor: "pointer",
                   transition: "all 0.2s ease",
                   boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                   marginTop: "8px"
                 }}
                 onMouseOver={(e) => {
                   e.currentTarget.style.backgroundColor = "#f8fafc";
                   e.currentTarget.style.borderColor = "#94a3b8";
                 }}
                 onMouseOut={(e) => {
                   e.currentTarget.style.backgroundColor = "#ffffff";
                   e.currentTarget.style.borderColor = "#cbd5e1";
                 }}
               >
                 Exit
               </button>
               <CalendlyPopupButton
                 url={CALENDLY_URL}
                 text="Express interest →"
                 className={classes["mbr-express-btn-web"]}
                 onClick={expressInterestClick}
                 triggerPopup={true}
                 moduleName="benchmark_results"
                 style={{ width: "280px", height: "48px", padding: "0 28px", borderRadius: "10px", display: "inline-flex", alignItems: "center", justifyContent: "center" }}
                 onCalendlyScheduled={onCalendlyScheduled}
               />
             </div>
          </div>

          {/* <Actions /> */}
          <center style={{ position: "absolute", bottom: "1%", width: "100%" }}>
            <a
              href="https://lntermsandconditions.blob.core.windows.net/tnc/benchmark_tnc.html"
              rel="noopener noreferrer"
              target="_blank"
              onClick={(e) => termsClick(e)}
            >
              LoRRI Benchmark Terms of Use and Disclaimers
            </a>
          </center>
        </>
      ) : (
        <>
            <div style={{ display: "flex", justifyContent: "flex-end", paddingRight: "4%", marginBottom: "8px" }}>
              <span id="definition" data-tip data-for="definition" style={{ cursor: "pointer" }}>
                <i className="fa fa-info-circle" style={{ fontSize: "20px", color: "#393185" }}></i>
            </span>
            <ReactTooltip
              className={`${classes["tooltip"]}`}
              id="definition"
              place="bottom"
              effect="float"
              backgroundColor="#393185 !important"
            >
              <div>
                <b>Median:</b> <br />
                The central value of freight based on available freight rates
                <br />
                <b>Max:</b> <br />
                The maximum value of freight based on available freight rates
                <br />
                <b>Note:</b> <br />
                Freight rates in LoRRI Benchmark are based on industry standard
                terms and conditions and may vary based on your specific terms,
                conditions and volume requirements
              </div>
            </ReactTooltip>
          </div>
          <MobileBody />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
                width: "96%",
                margin: "12px auto 0 auto",
              }}
            >
              <button
                className={classes["btn-exit-small"]}
                onClick={goToStart}
              >
                Exit
              </button>
              {allowedrate === "yes" && (
                <RatesModal
                  screenName="My Freight Benchmark"
                  moduleName="Get Rates"
                  activityName={`Get Rates Button Clicked`}
                  buttonLabel={"Get Spot Rates"}
                  content={
                    <NewEnquiry
                      resetData={resetData}
                      backbutton={true}
                      newSpot={true}
                      rspl={allLanesForRates}
                    />
                  }
                  id={`rates_modal_all_mobile`}
                  disabled={lspload}
                  size="fullscreen"
                  title="My Enquiries"
                  buttonClass={classes["btn-get-spot-rates"]}
                  overflowStyles={{
                    overflow: "hidden",
                    top: "9%",
                    zIndex: "999",
                  }}
                  closeButtonId={`close_contact_all_mobile`}
                />
              )}
            </div>

          {/* <Actions /> */}
          <center
            style={{ position: "absolute", bottom: "-1%", width: "100%" }}
          >
            <a
              href="https://lntermsandconditions.blob.core.windows.net/tnc/benchmark_tnc.html"
              rel="noopener noreferrer"
              target="_blank"
              onClick={(e) => termsClick(e)}
            >
              LoRRI Benchmark Terms of Use and Disclaimers
            </a>
          </center>
        </>
      )}
    </>
  );
};

export default BenchMarkResults;
